import { Fragment } from 'react';

import styles from './styles.module.scss';

type Label = React.ReactNode;
type Value = string | undefined | React.ReactNode;
type Actions = React.ReactNode;

export interface InfoCardProps {
	values: [Label, Value, Actions?][];
	className?: string;
	alignHelp?: 'start' | 'space-between';
}

export const InfoCard = ({ values, className, alignHelp = 'start' }: InfoCardProps) => {
	return (
		<div className={`${styles.info_card} ${className ? className : ''}`}>
			{values.map(([key, value, actions], index) => (
				<Fragment key={index}>
					<div className={`${styles.info_card__title} ${alignHelp}`}>{key}</div>

					<div className={styles.info_card__content}>
						<div className={styles.info_card__content_value}>{value}</div>
						{actions ? <div className={styles.info_card__actions}>{actions}</div> : null}
					</div>
				</Fragment>
			))}
		</div>
	);
};
